/**
 *
 * key
 *
 */

 const key = 'Y3JtVW5Bc3NpZ25lZA=='

 export default key
 